import type { ReactNode } from "react";
import { useMediaQuery } from "react-responsive";

export const DESKTOP_BREAKPOINT = 1024;

const device = {
  mobile: `(max-width: ${DESKTOP_BREAKPOINT - 1}px)`,
  desktop: `(min-width: ${DESKTOP_BREAKPOINT}px)`,
};

interface IResponsive {
  children: ReactNode;
}

export const useIsMobile = (): boolean =>
  useMediaQuery({
    query: device.mobile,
  });

export const Mobile = ({ children }: IResponsive) => {
  const isMobileQuery = useIsMobile();

  return isMobileQuery ? children : null;
};

export const useIsDesktop = (): boolean =>
  useMediaQuery({
    query: device.desktop,
  });

export const Desktop = ({ children }: IResponsive) => {
  const isDesktopQuery = useIsDesktop();

  return isDesktopQuery ? children : null;
};

export const getCurrentScreenInfo = () => {
  const width = window.screen.width;
  const height = window.screen.height;
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  return {
    screenResolution: `${width} x ${height}`,
    screenViewport: `${viewportWidth} x ${viewportHeight}`,
  };
};
